import api from "./api";

export async function getTags(field= '', paginate = false, currentPage= 0) {
    return await api.get(`/tags?tag_type_code=${field}&paginate=${paginate}&page=${currentPage}`)
        .then(response => response.data)
        .catch(() => console.log('error tags'))
}

export async function getTagId(id) {
    return await api.get(`/tags/${id}`)
        .then(response => response.data)
        .catch(() => console.log('error tags'))
}

export function setTag(data) {
    return api.post('/tags', data)
}

export function editTag(id, data) {
    return api.put(`/tags/${id}`, data)
}

export function delTag(id) {
    return api.delete(`/tags/${id}`)
}
